module.exports = __webpack_public_path__ + "media/images/games/rocket-league/hiw-3-a32c00727ac6a762fb56499b169e0f6c.jpg";